export default [
{path:"/index",redirect:'/'},    
{
path: '/',
meta: {
    title: '华宜供应链',
    keepAlive: true
},
component: r => require.ensure([], () => r(require('../views/index/index')), `/`),
}, 
{
    path: '/prod',
    meta: {
        title: '商品详情',
    },
    component: r => require.ensure([], () => r(require('../views/index/prod')), `/`),
}, 


{
    path: '/prodlist',
    meta: {
        title: '搜索列表',
    },
    component: r => require.ensure([], () => r(require('../views/index/prodlist')), `/`),
}


];


// WEBPACK FOOTER //
// ./src/router/config.js